import { NavLink, Link } from "react-router-dom";
import {
	FaTachometerAlt,
	FaEnvelope,
	FaHistory,
	FaKey,
	FaSignOutAlt,
} from "react-icons/fa";
import { FiUserPlus } from "react-icons/fi";
import logo from "../assets/logo.png";

const Sidebar = () => {
	const linkClass =
		"flex items-center gap-3 px-4 py-3 hover:bg-blue-100 transition-colors rounded-md text-sm font-medium";
	const activeClass = "bg-blue-100 text-blue-700 font-semibold";

	// Get user role from sessionStorage
	const userRole = sessionStorage.getItem("role");

	return (
		<div className='w-64 min-h-screen bg-white border-r p-4 shadow-sm'>
			<div className='flex items-center justify-center mb-6'>
				<Link to='/'>
					<img
						src={logo}
						alt='Bank Logo'
						className='h-20 w-20 object-contain rounded-full border border-gray-300 shadow-sm cursor-pointer transition duration-200 hover:shadow-md'
					/>
				</Link>
			</div>

			<nav className='flex flex-col space-y-2'>
				<NavLink
					to='/'
					end
					className={({ isActive }) =>
						`${linkClass} ${isActive ? activeClass : ""}`
					}
				>
					<FaTachometerAlt /> Dashboard
				</NavLink>
				<NavLink
						to='/messages'
						end
						className={({ isActive }) =>
							`${linkClass} ${isActive ? activeClass : ""}`
						}
					>
					<FaEnvelope /> Messages
					</NavLink>
				<NavLink
    to='/messages/international'
    className={({ isActive }) =>
        `${linkClass} ${isActive ? activeClass : ""}`
    }
>
    <FaEnvelope /> International Messages
</NavLink>
				<NavLink
					to='/logs'
					className={({ isActive }) =>
						`${linkClass} ${isActive ? activeClass : ""}`
					}
				>
					<FaHistory /> Logs
				</NavLink>

				{/* Conditionally render Create User link */}
				{userRole === "admin" && (
					<NavLink
						to='/create-user'
						className={({ isActive }) =>
							`${linkClass} ${isActive ? activeClass : ""}`
						}
					>
						<FiUserPlus /> Create User
					</NavLink>
				)}

				<NavLink
					to='/reset-password'
					className={({ isActive }) =>
						`${linkClass} ${isActive ? activeClass : ""}`
					}
				>
					<FaKey /> Reset Password
				</NavLink>
				<NavLink
					to='/logout'
					className={({ isActive }) =>
						`${linkClass} ${isActive ? activeClass : ""}`
					}
				>
					<FaSignOutAlt /> Logout
				</NavLink>
			</nav>
		</div>
	);
};

export default Sidebar;
